export default "__VITE_ASSET__cea2d34c__"